module.exports = __webpack_public_path__ + "spinner.d13ffea403619e59f95e1b4636d95f98.gif";